// src/utils/platformMode.ts
// Phase 4 — Test Mode / Beta activation store
// Written by: Settings page (Tier A only)
// Read by: App.tsx (BETA banner), any module needing to behave differently in test vs prototype mode

type PlatformMode = 'PROTOTYPE' | 'TEST'

let _mode: PlatformMode       = 'PROTOTYPE'
let _enabledAt: string | null = null
let _enabledByName: string | null = null

// Initialise from localStorage on module load (persists across page refreshes)
try {
  const stored = localStorage.getItem('tp_platform_mode')
  if (stored) {
    const { mode, enabledAt, enabledByName } = JSON.parse(stored)
    if (mode === 'TEST') { _mode = 'TEST'; _enabledAt = enabledAt; _enabledByName = enabledByName }
  }
} catch { /* ignore — may fail in SSR or restricted contexts */ }

export function getPlatformMode(): PlatformMode { return _mode }
export function isTestMode(): boolean            { return _mode === 'TEST' }

export function enableTestMode(enabledByName: string): void {
  _mode          = 'TEST'
  _enabledAt     = new Date().toISOString()
  _enabledByName = enabledByName
  try { localStorage.setItem('tp_platform_mode', JSON.stringify({ mode: 'TEST', enabledAt: _enabledAt, enabledByName })) } catch {}
  // Notify same-tab listeners (storage event only fires in OTHER tabs)
  window.dispatchEvent(new CustomEvent('tp-mode-changed', { detail: { mode: 'TEST' } }))
}

export function disableTestMode(): void {
  _mode          = 'PROTOTYPE'
  _enabledAt     = null
  _enabledByName = null
  try { localStorage.removeItem('tp_platform_mode') } catch {}
  window.dispatchEvent(new CustomEvent('tp-mode-changed', { detail: { mode: 'PROTOTYPE' } }))
}

export function getTestModeInfo(): { enabledAt: string | null; enabledByName: string | null } {
  return { enabledAt: _enabledAt, enabledByName: _enabledByName }
}
